import { Injectable } from '@angular/core';
import { Filters } from '../interfaces/filters';

export interface HistoricalArchiveSearchState {
  typeFilter: number;
  filters: Filters | string | null;
  formValues: Filters | null;
  yearFormat: string | null;
  itemsPerPage: number;
  currentPageIndex: number;
}

export interface ArtisticArchiveSearchState {
  query: string | null;
  itemsPerPage: number;
  currentPageIndex: number;
}

export interface InventoryHistoricalSearchState {
  idcategory: number | null;
  idsubcategory: number | null;
  rack: string | null;
  shelf: string | null;
  case: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class ArchiveSearchStateService {

  private historicalState: HistoricalArchiveSearchState | null = null;
  private artisticState: ArtisticArchiveSearchState | null = null;
  private inventoryHistoricalState: InventoryHistoricalSearchState | null = null;

  getHistorical(): HistoricalArchiveSearchState | null {
    return this.historicalState;
  }

  setHistorical(state: HistoricalArchiveSearchState): void {
    this.historicalState = {
      ...state,
      formValues: state.formValues ? { ...state.formValues, categories: state.formValues.categories ? [...state.formValues.categories] : null } : null,
    };
  }

  clearHistorical(): void {
    this.historicalState = null;
  }

  getArtistic(): ArtisticArchiveSearchState | null {
    return this.artisticState;
  }

  setArtistic(state: ArtisticArchiveSearchState): void {
    this.artisticState = { ...state };
  }

  clearArtistic(): void {
    this.artisticState = null;
  }

  getInventoryHistorical(): InventoryHistoricalSearchState | null {
    return this.inventoryHistoricalState;
  }

  setInventoryHistorical(state: InventoryHistoricalSearchState): void {
    this.inventoryHistoricalState = { ...state };
  }

  clearInventoryHistorical(): void {
    this.inventoryHistoricalState = null;
  }

}
